module.exports = __webpack_public_path__ + "img/human_body.36012529.svg";